<template>
  <el-form
    :label-position="formLabelPosition"
    class="form"
    label-width="250px"
    v-if="scenario && scenario.all_price_keys.length > 1">
    <div class="heading"><h3>Please select your players</h3></div>
    <el-alert :type="playersAlertType" :closable="false" class="players-alert" show-icon>
      <template slot="title">
        You have selected
        <strong>{{selectedPlayers}} out of {{totalPlayers}}</strong>
        players required to complete your booking
      </template>
    </el-alert>
    <el-form-item :label="pk.description" v-for="pk in scenario.all_price_keys">
      <el-input-number :min="0" :value="selectedPriceKeys[pk.id]" :key="pk.id" @input="setPriceKeyQty($event, pk)" :max="selectedPlayers + peoplePerPriceKey(pk.id) > totalPlayers ? selectedPriceKeys[pk.id] : 100"></el-input-number>
      <span class="pk-amount" v-if="selectedPriceKeys[pk.id]">
        <i18n-n :value="pk.value * selectedPriceKeys[pk.id]" format="currency"></i18n-n>
      </span>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex'
  import formMixin from '../mixins/formMixin'

  export default {
    mixins: [formMixin],
    props: ['scenario'],
    computed: {
      ...mapState({
        selectedPriceKeys: state => state.booking.options.priceKeys,
        order: state => state.order.order
      }),
      playersAlertType() {
        if (this.selectedPlayers > this.totalPlayers)
          return 'error'
        if (this.selectedPlayers < this.totalPlayers)
          return 'warning'
        return 'success'
      },
      totalPlayers() {
        return this.order.adults + this.order.juniors
      },
      selectedPlayers() {
        let players = 0
        for (let id in this.selectedPriceKeys) {
          const qty = this.selectedPriceKeys[id]
          players += qty * this.peoplePerPriceKey(id)
        }
        return players
      }
    },
    data() {
      return {
        error: null
      }
    },
    methods: {
      peoplePerPriceKey(id) {
        const pk = this.scenario.all_price_keys.find((pk) => pk.id == id)
        const m = pk.tag.match(/^PLAYERS=(\d+)$/)
        const people = m ? parseInt(m[1]) : pk.people
        return people
      },
      setPriceKeyQty(qty, pk) {
        if (typeof qty != 'undefined') {
          this.$store.dispatch('booking/setPriceKeyQty', { [pk.id]: qty })
        }
      },
      validate() {
        let isValid = true
      }
    },
    created() {
      this.$store.commit('booking/setPriceKeys', null)
      if (this.scenario.all_price_keys.length == 1) {
        const pk = this.scenario.all_price_keys[0]
        //let pkQty = this.order.adults
        const m = pk.tag.match(/^PLAYERS=([\d\-]+)$/)
        let people = pk.people
        if (m) {
          console.log('m', m)
          if (m[1].indexOf('-')) {
            const [minPeople, maxPeople] = m[1].split('-').map((x) => parseInt(x))
            console.log('min', minPeople, maxPeople)
            people = maxPeople
          } else {
            people = parseInt(m[1])
          }
        }
        const pkQty = Math.ceil(this.order.adults/people)
        console.log('qty', pkQty, this.order.adults, people)

        this.$store.dispatch('booking/setPriceKeyQty', { [pk.id]: pkQty })
      } else {
        this.scenario.all_price_keys.forEach((pk) => {
          if (this.selectedPriceKeys[pk.id] == null)
            this.$store.dispatch('booking/setPriceKeyQty', { [pk.id]: 0 })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pk-amount {
    margin-left: 1em;
  }
  .players-alert {
    margin-bottom: 1em;
  }
</style>
